import {
    ResponsiveContainer,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid,
    Label,
    ComposedChart,
    Cell
} from 'recharts';
import { Box, Typography } from '@mui/material';
import { formatGraphAxis, FertilizerLegend, AgrochemicalsTooltip, formatTicker } from '../utils/graph-utils';
import { composedChartMargin, barGraphFontSize, labelOffSet, legendHeight, legendIconSize, responsiveContainerHeight, fertilizerBarSize, agrochemicalsColors, agrochemicalsLegendItems, chartOffset } from '../constants/graph-constants';

/**
 * 
 * @param {Object} props 
 * @param {{category: string, total: number, type: string}[]} props.data Graph data from backend
 * @param {string} props.type
 * @param {string} props.group "Twee Jonge Gezellen"
 * @param {string} props.year "2024"
 * @param {string} props.unit This argument populates the Y axis with the corresponding unit value passed here.
 * @returns {JSX.Element} The facility's bar graph which displays an array of fertilizer items
 */

export default function AgrochemicalsFacilityBarGraph({ data, type, group, year, unit }) {
    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <Typography variant="h6" align="center" gutterBottom>
                {group} {type} {year} per Facility
            </Typography>
            <ResponsiveContainer width="100%" height={responsiveContainerHeight}>
                <ComposedChart data={data} margin={composedChartMargin}>
                    <CartesianGrid stroke="#f5f5f5" />
                    <XAxis
                        dataKey="category"
                        fontSize={barGraphFontSize}
                    >
                        <Label value="Agrochemical" position='insideBottom' offset={labelOffSet} fontSize={barGraphFontSize} />
                    </XAxis>
                    <YAxis
                        fontSize={barGraphFontSize}
                        domain={([dataMin, dataMax]) => { const yAxisDisplayMax = formatGraphAxis(dataMax, dataMin); return yAxisDisplayMax }}
                        tickFormatter={value => formatTicker(value)}
                    >
                        <Label value={unit} angle={-90} position={'insideLeft'} offset={chartOffset} fontSize={barGraphFontSize} />
                    </YAxis>
                    <Tooltip content={<AgrochemicalsTooltip variant='facility' />} />
                    <Legend content={<FertilizerLegend legendItems={agrochemicalsLegendItems} />} iconSize={legendIconSize} verticalAlign='top' height={legendHeight} />
                    <Bar
                        dataKey={'total'}
                        name={'Total'}
                        barSize={fertilizerBarSize}
                    >
                        {data?.map((entry, index) => (
                            <Cell
                                key={index}
                                fill={agrochemicalsColors[entry.type] || '#ccc'}
                            />
                        ))
                        }
                    </Bar>
                </ComposedChart>
            </ResponsiveContainer>
        </Box>
    );
}